export const breadcrumb = [
  {
    link: '/',
    label: 'home',
  },
  {
    link: '/download',
    label: 'Download Sitemule Model Studio',
  },
];

export const topNavigation = [
  {
    text: 'About',
    link: '/business-first-then-technology',
    special: false,
    textOver: 'business first then technology',
  },
  {
    text: 'Contact',
    link: '/business-first-then-technology#contact',
    special: false,
    textOver: 'contact',
  },
  //   {
  //     text: 'Download',
  //     link: '/download',
  //     special: false,
  //     textOver: 'download',
  //   },
];

export const content = [
  {
    text: 'Customers',
    link: '/download',
  },
  {
    text: 'Three Icecap bullets',
    link: '/download',
  },
  {
    text: 'What you get out of the box',
    link: '/download',
  },
  {
    text: 'Valuble metrics',
    link: '/download',
  },
  {
    text: 'Three issues solved instantly',
    link: '/download',
  },
  {
    text: 'Insights  customers',
    link: '/download',
  },
  {
    text: 'Learning Icecap',
    link: '/download',
  },
  {
    text: 'Pricing',
    link: '/download',
  },
  {
    text: 'Meet the core Icecap Team',
    link: '/download',
  },
  {
    text: 'Book introduction with an expert',
    link: '/download',
  },
  {
    text: 'Download Icecap pitch deck',
    link: '/download',
  },
  {
    text: 'Contact',
    link: '/download',
  },
];
